import { FC, ReactNode } from 'react';
import { HStack, ModalInfo, VStack } from '@bpba/ui-components';
import { ModalHeader } from './ModalHeader';
import { CloseIconContainer } from './CloseIconContainer';
import { ModalError } from './ModalError';
import { ConfirmButton } from './ConfirmButton';
import { CancelButton } from './CancelButton';

const BUTTON_FONT_SIZE = 14;
const BUTTON_LINE_HEIGHT = '18px';
const HEADER_FONT_COLOR = 'white';
const MODAL_BACKGROUND_COLOR = 'white';

type Props = {
  show: boolean;
  children?: ReactNode;
  title?: ReactNode;
  cancelLabel?: string;
  onCancel?: () => void;
  showCancelButton?: boolean;
  confirmLabel?: string;
  onConfirm?: () => void;
  showConfirmButton?: boolean;
  showErrorMessage?: boolean;
  enableConfirmButton?: boolean;
  errorMessage?: string;
  childrenAfterButtons?: ReactNode;
};

export const Modal: FC<Props> = (props) => {
  const {
    show,
    children,
    title,
    cancelLabel,
    onCancel,
    showCancelButton,
    confirmLabel,
    onConfirm,
    showConfirmButton,
    showErrorMessage,
    enableConfirmButton,
    errorMessage,
    childrenAfterButtons,
  } = { ...props };
  const showButtonsContainer = showCancelButton || showConfirmButton;

  return (
    <ModalInfo
      show={show}
      header={<ModalHeader title={title} color={HEADER_FONT_COLOR} tabIndex={0} />}
      closable={false}
      onClose={onCancel}
      closeIcon={<CloseIconContainer aria-label="Cerrar" color={HEADER_FONT_COLOR} />}
      padding="0"
      bg={MODAL_BACKGROUND_COLOR}
      borderRadius="12px 12px 8px 8px"
      role={undefined}
    >
      <VStack paddingBottom="32px" paddingX={['16px', '24px']}>
        {children}

        <ModalError show={showErrorMessage} errorMessage={errorMessage} />

        <HStack justifyContent="center" marginTop={24} display={showButtonsContainer ? 'flex' : 'none'}>
          <CancelButton
            show={showCancelButton}
            onClickCallback={onCancel}
            label={cancelLabel}
            addMarginRight={showConfirmButton}
            fontSize={BUTTON_FONT_SIZE}
            lineHeight={BUTTON_LINE_HEIGHT}
            backgroundColor={MODAL_BACKGROUND_COLOR}
          />

          <ConfirmButton
            show={showConfirmButton}
            enable={enableConfirmButton}
            onClickCallback={onConfirm}
            label={confirmLabel}
            fontSize={BUTTON_FONT_SIZE}
            lineHeight={BUTTON_LINE_HEIGHT}
          />
        </HStack>

        {childrenAfterButtons}
      </VStack>
    </ModalInfo>
  );
};

Modal.defaultProps = {
  show: false,
  cancelLabel: 'Cancelar',
  showCancelButton: true,
  confirmLabel: 'Confirmar',
  showConfirmButton: true,
  enableConfirmButton: true,
};